import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UsersList} from "../users-list";
import {Message} from "../message";

@Component({
    selector: 'kiwi-new-message',
    templateUrl: './new-message.component.html',
    styleUrls: ['./new-message.component.scss'],
    host: { 'class': 'cell auto grid-y' },
    standalone: false
})
export class NewMessageComponent {
    @Input()
    recipients: UsersList[];

    @Output()
    usersListDeleted = new EventEmitter<UsersList>();

    @Output()
    messageSent = new EventEmitter<Message>();

    message = new Message('', '', undefined, undefined, '');

    onUsersListDeleted(usersList: UsersList) {
        this.usersListDeleted.emit(usersList);
    }

    sendMessage() {
        this.messageSent.emit(this.message);
        this.message = new Message('', '', undefined, undefined, '');
    }
}
